// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import letterRecipientEntity from './entities/letter-recipient.json';
import letterRecipientMenu from '../pages/letter-recipient/menu.json';
import letterRecipientFullForm from '../pages/letter-recipient/forms/full.json';
import letterRecipientContextForm from '../pages/letter-recipient/forms/context.json';
import letterRecipientMiniForm from '../pages/letter-recipient/forms/mini.json';
import letterRecipientLookupForm from '../pages/letter-recipient/forms/lookup.json';
import letterRecipientTableView from '../pages/letter-recipient/views/table.json';
import letterRecipientCardsView from '../pages/letter-recipient/views/cards.json';
import letterRecipientDashboardView from '../pages/letter-recipient/views/dashboard.json';

/** Тип запису «Одержувач листа» зі сторінками пакета: меню, форми та подання з pages/letter-recipient/. */
export const letterRecipientDefinition: IRecordTypeDefinition = {
  ...letterRecipientEntity,
  views: assembleViewSet({
      table: letterRecipientTableView,
      cards: letterRecipientCardsView,
      dashboard: letterRecipientDashboardView,
  }),
  form: letterRecipientFullForm,
  forms: { full: letterRecipientFullForm, context: letterRecipientContextForm, mini: letterRecipientMiniForm, lookup: letterRecipientLookupForm },
  menu: letterRecipientMenu,
} as IRecordTypeDefinition;
